<template>
  <div class="letters">
    <div class="letters__images">
      <div class="letters__images-item letters__images-item--1 rellax" data-rellax-speed="-1.1" data-rellax-percentage="0.4"></div>
      <div class="letters__images-item letters__images-item--2 rellax" data-rellax-speed="0.4" data-rellax-percentage="0.4"></div>
      <div class="letters__images-item letters__images-item--3 rellax" data-rellax-speed="0.4" data-rellax-percentage="0.4"></div>
      <div class="letters__images-item letters__images-item--4 rellax" data-rellax-speed="-0.2" data-rellax-percentage="0.4"></div>
    </div>
    <div class="letters__list" id="scene">
      <div data-calibrate-y="true" v-scroll-to="'#block-n'" data-calibrate-x="true" data-depth="0.1" class="letters__item letters__item--1">Н. <div class="letters__item-text">Непереносимость<br> английской речи</div></div>
      <div data-calibrate-y="true" v-scroll-to="'#block-v'" data-calibrate-x="true" data-depth="0.1" class="letters__item letters__item--2">В. <div class="letters__item-text">Вседозволенность</div></div>
      <div data-calibrate-y="true" v-scroll-to="'#block-m'" data-calibrate-x="true" data-depth="-0.1" class="letters__item letters__item--3">М. <div class="letters__item-text">Метрополь</div></div>
      <div data-calibrate-y="true" v-scroll-to="'#block-f'" data-calibrate-x="true" data-depth="0.1" class="letters__item letters__item--4">Ф. <div class="letters__item-text">Фокстрот</div></div>
      <div data-calibrate-y="true" v-scroll-to="'#block-sh'" data-calibrate-x="true" data-depth="-0.1" class="letters__item letters__item--5">Ш. <div class="letters__item-text">Шпион</div></div>
      <div data-calibrate-y="true" v-scroll-to="'#block-t'" data-calibrate-x="true" data-depth="0.1" class="letters__item letters__item--6">Т. <div class="letters__item-text">Театр</div></div>
      <div data-calibrate-y="true" v-scroll-to="'#block-b'" data-calibrate-x="true" data-depth="0.1" class="letters__item letters__item--7">Б. <div class="letters__item-text">Буржуа</div></div>
      <div data-calibrate-y="true" v-scroll-to="'#block-ch'" data-calibrate-x="true" data-depth="0.1" class="letters__item letters__item--8">Ч. <div class="letters__item-text">Чарльстон</div></div>
      <div data-calibrate-y="true" v-scroll-to="'#block-l'" data-calibrate-x="true" data-depth="-0.1" class="letters__item letters__item--9">Л. <div class="letters__item-text">Любовь<br>&<br>Ладан</div></div>
      <div data-calibrate-y="true" v-scroll-to="'#block-r'" data-calibrate-x="true" data-depth="0.1" class="letters__item letters__item--10">Р. <div class="letters__item-text">Ревущие<br>20-е</div></div>
      <div data-calibrate-y="true" v-scroll-to="'#block-a'" data-calibrate-x="true" data-depth="-0.1" class="letters__item letters__item--11">А. <div class="letters__item-text">Александр</div></div>
      <div data-calibrate-y="true" v-scroll-to="'#block-g'" data-calibrate-x="true" data-depth="-0.1" class="letters__item letters__item--12">Г. <div class="letters__item-text">Грузчик</div></div>
    </div>
  </div>
</template>

<script>
import Parallax from 'parallax-js'
import Rellax from 'rellax'

export default {
  name: 'Main',
  mounted() {
    var scene = document.getElementById('scene');
    new Parallax(scene, {
        relativeInput: true,
        calibrateX: true,
        calibrateY: true,
        pointerEvents: true,
    });
    new Rellax('.rellax');
  }
}
</script>

<style lang="sass">
  .letters
    color: #000
    font-family: 'ZnikomitNo25'
    font-size: vw(125.8px)
    position: relative
    height: vw(640px)
    @media screen and (max-width: 999px)
      display: none !important
    &__images
      position: absolute
      &-item
        &--1
          width: vw(231px)
          height: vw(163px)
          background-image: url(../assets/img/image-1.jpg)
          background-repeat: no-repeat
          background-position: 50% 50%
          background-size: cover
          position: absolute
          left: vw(115px)
          top: vw(81px)
        &--2
          width: vw(165px)
          height: vw(238px)
          background-image: url(../assets/img/image-2.jpg)
          background-repeat: no-repeat
          background-position: 50% 50%
          background-size: cover
          position: absolute
          left: vw(597px)
          top: vw(-48px)
        &--3
          width: vw(240px)
          height: vw(160px)
          background-image: url(../assets/img/image-3.jpg)
          background-repeat: no-repeat
          background-position: 50% 50%
          background-size: cover
          position: absolute
          left: vw(964px)
          top: vw(-6px)
        &--4
          width: vw(260px)
          height: vw(184px)
          background-image: url(../assets/img/image-4.jpg)
          background-repeat: no-repeat
          background-position: 50% 50%
          background-size: cover
          position: absolute
          left: vw(607px)
          top: vw(371px)
    &__item
      display: none
      width: vw(145px)
      height: vw(140px)
      padding-left: vw(16px)
      border: 1px solid #000
      background-color: #fff
      position: absolute
      justify-content: center
      align-items: center
      cursor: pointer
      &:hover
       >.letters__item-text
         display: block !important
      &:before
        content: ''
        display: block
        width: vw(49px)
        height: vw(49px)
        position: absolute
        border: 1px solid #000
        border-bottom: none
        border-right: none
        top: vw(-6.5px)
        left: vw(-6.5px)
        transition: all 300ms
      &:after
        content: ''
        display: block
        width: vw(49px)
        height: vw(49px)
        position: absolute
        border: 1px solid #000
        border-top: none
        border-left: none
        bottom: vw(-6.5px)
        right: vw(-6.5px)
        transition: all 300ms
      &--1
       display: flex
       top: vw(-21px) !important
       left: vw(285px) !important
       .letters__item-text
        left: vw(-240px)
        top: vw(20px)
      &--2
       display: flex
       top: vw(27px) !important
       left: vw(509px) !important
       .letters__item-text
        left: vw(8px)
        top: vw(162px)
      &--3
       display: flex
       top: vw(-75px) !important
       left: vw(892px) !important
       background-color: #740D0C
       border-color: #740D0C
       color: #fff
       padding-left: vw(8px)
       &:before
        border-color: #740D0C
       &:after
        border-color: #740D0C
       .letters__item-text
        left: vw(-240px)
        font-size: vw(30px)
        top: vw(-2px)
        color: #000
      &--4
       display: flex
       top: vw(186px) !important
       left: vw(363px) !important
       background-color: #E1C99C
       border-color: #E1C99C
       color: #fff
       &:before
        border-color: #E1C99C
       &:after
        border-color: #E1C99C
       .letters__item-text
        left: vw(8px)
        top: vw(152px)
        text-align: left
        color: #000
      &--5
       display: flex
       top: vw(119px) !important
       left: vw(754px) !important
       padding-left: vw(19px)
       padding-top: vw(7px)
       .letters__item-text
        left: vw(8px)
        top: vw(152px)
        text-align: left
        color: #000
      &--6
       display: flex
       top: vw(192px) !important
       left: vw(964px) !important
       padding-left: vw(19px)
       padding-top: vw(7px)
       .letters__item-text
        left: vw(168px)
        top: vw(112px)
        text-align: left
        color: #000
      &--7
       display: flex
       top: vw(118px) !important
       left: vw(1159px) !important
       padding-left: vw(18px)
       padding-top: vw(0px)
       .letters__item-text
        left: vw(8px)
        top: vw(152px)
        text-align: left
        color: #000
      &--8
       display: flex
       top: vw(258px) !important
       left: vw(160px) !important
       padding-left: vw(18px)
       padding-top: vw(0px)
       .letters__item-text
        left: vw(8px)
        top: vw(152px)
        text-align: left
        color: #000
      &--9
       display: flex
       top: vw(397px) !important
       left: vw(388px) !important
       padding-left: vw(18px)
       padding-top: vw(0px)
       .letters__item-text
        left: vw(-200px)
        top: vw(30px)
        text-align: center
      &--10
       display: flex
       top: vw(274px) !important
       left: vw(562px) !important
       padding-left: vw(18px)
       padding-top: vw(0px)
       .letters__item-text
        left: vw(168px)
        top: vw(12px)
        text-align: left
        color: #000
      &--11
       display: flex
       top: vw(351px) !important
       background-color: #000
       color: #fff
       left: vw(840px) !important
       padding-left: vw(18px)
       padding-top: vw(0px)
       .letters__item-text
        left: vw(48px)
        top: vw(152px)
        text-align: left
        color: #000
      &--12
       display: flex
       top: vw(402px) !important
       left: vw(1082px) !important
       padding-left: vw(18px)
       padding-top: vw(0px)
       .letters__item-text
        left: vw(-48px)
        top: vw(-47px)
        text-align: left
        color: #000
      &-text
        display: none
        font-size: vw(24px)
        text-align: right
        width: vw(220px)
        line-height: vw(32px)
        position: absolute
</style>
